import {
  newActionCtx,
  newLiveCtx,
  newProductAnalyticsCtx,
  newTeamCtx,
  newVenueCtx,
  newViewCtx,
} from './helpers/contexts';
import { createBPv2EventFactory } from './helpers/utils';

function defaultContexts() {
  return {
    ...newTeamCtx(),
    ...newVenueCtx(),
    ...newLiveCtx({ live_feature: null }),
    ...newProductAnalyticsCtx({
      product: 'analysis',
      feature: 'venues',
      location: 'widget',
    }),
  };
}

export function trackVenuesViewPoll(pollId: string) {
  const trackEvent = createBPv2EventFactory(
    'vimeo.venues_view_poll',
    1,
    () => ({
      ...defaultContexts(),
      ...newViewCtx('impression'),
    }),
    {},
  );

  trackEvent({
    poll_id: pollId,
  });
}

export function trackVenuesAddPollVote(
  pollId: string,
  pollOptionId: string,
  isPollOptionCorrect: boolean,
) {
  const trackEvent = createBPv2EventFactory(
    'vimeo.venues_add_poll_vote',
    1,
    () => ({
      ...defaultContexts(),
      ...newActionCtx('click'),
    }),
    {},
  );

  trackEvent({
    poll_id: pollId,
    poll_option_id: pollOptionId,
    is_poll_option_correct: isPollOptionCorrect,
  });
}

export function trackVenuesViewQa(qaSessionId: string) {
  const trackEvent = createBPv2EventFactory(
    'vimeo.venues_view_qa',
    1,
    () => ({
      ...defaultContexts(),
      ...newViewCtx('impression'),
    }),
    {},
  );

  trackEvent({
    qa_session_id: qaSessionId,
  });
}

export function trackVenuesAddQaQuestion(
  qaSessionId: string,
  qaQuestionId: string,
  isQaQuestionAnonymous: boolean,
) {
  const trackEvent = createBPv2EventFactory(
    'vimeo.venues_add_qa_question',
    1,
    () => ({
      ...defaultContexts(),
      ...newActionCtx('type'),
    }),
    {},
  );

  trackEvent({
    qa_session_id: qaSessionId,
    qa_question_id: qaQuestionId,
    is_qa_question_anonymous: isQaQuestionAnonymous,
  });
}

export function trackVenuesAddQaQuestionReaction(
  qaSessionId: string,
  qaQuestionId: string,
  isQaQuestionAnonymous: boolean,
  reactionType: string, // enum: upvote, downvote ?
) {
  const trackEvent = createBPv2EventFactory(
    'vimeo.venues_add_qa_question_reaction',
    1,
    () => ({
      ...defaultContexts(),
      ...newActionCtx('click'),
    }),
    {},
  );

  trackEvent({
    qa_session_id: qaSessionId,
    qa_question_id: qaQuestionId,
    is_qa_question_anonymous: isQaQuestionAnonymous,
    reaction_type: reactionType,
  });
}

export function trackVenuesRemoveQaQuestionReaction(
  qaSessionId: string,
  qaQuestionId: string,
  isQaQuestionAnonymous: boolean,
  reactionType: string, // enum: upvote, downvote ?
) {
  const trackEvent = createBPv2EventFactory(
    'vimeo.venues_remove_qa_question_reaction',
    1,
    () => ({
      ...defaultContexts(),
      ...newActionCtx('click'),
    }),
    {},
  );

  trackEvent({
    qa_session_id: qaSessionId,
    qa_question_id: qaQuestionId,
    is_qa_question_anonymous: isQaQuestionAnonymous,
    reaction_type: reactionType,
  });
}

export function trackVenuesAddQaReply(
  qaSessionId: string,
  qaQuestionId: string,
  isQaQuestionAnonymous: boolean,
  qaReplyId: string,
) {
  const trackEvent = createBPv2EventFactory(
    'vimeo.venues_add_qa_reply',
    1,
    () => ({
      ...defaultContexts(),
      ...newActionCtx('type'),
    }),
    {},
  );

  trackEvent({
    qa_session_id: qaSessionId,
    qa_question_id: qaQuestionId,
    is_qa_question_anonymous: isQaQuestionAnonymous,
    qa_reply_id: qaReplyId,
  });
}

export function trackVenuesAddQaReplyReaction(
  qaSessionId: string,
  qaQuestionId: string,
  isQaQuestionAnonymous: boolean,
  qaReplyId: string,
  reactionType: string, // enum: upvote, downvote ?
) {
  const trackEvent = createBPv2EventFactory(
    'vimeo.venues_remove_qa_question_reaction',
    1,
    () => ({
      ...defaultContexts(),
      ...newActionCtx('click'),
    }),
    {},
  );

  trackEvent({
    qa_session_id: qaSessionId,
    qa_question_id: qaQuestionId,
    is_qa_question_anonymous: isQaQuestionAnonymous,
    qa_reply_id: qaReplyId,
    reaction_type: reactionType,
  });
}
